"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var EmailCategory;
(function (EmailCategory) {
    EmailCategory["UNREAD_MESSAGES"] = "unread_messages";
    EmailCategory["PUBLIC_LIVECHAT"] = "public_livechat";
})(EmailCategory = exports.EmailCategory || (exports.EmailCategory = {}));
class EmailSettingsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            UserEmailSetting: () => `
        ... on UserEmailSetting {
          email
          settings
        }
      `,
        };
    }
    generateToken() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("emailSettingsTokenGenerate");
        });
    }
    find({ token }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("emailSettingsGet", { token }, this.getFragment("UserEmailSetting"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("emailSettingsUpdate", { data }, this.getFragment("UserEmailSetting"));
        });
    }
}
exports.EmailSettingsProvider = EmailSettingsProvider;
//# sourceMappingURL=EmailSettingsProvider.js.map